module.exports = __webpack_public_path__ + "static/media/independent.co.uk_news_uk_politics_brexit-anger-bregret-leave-voters-protest-vote-thought-uk-stay-in-eu-remain-win-a7102516.html_plot.0d512d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/independent.co.uk_news_uk_politics_brexit-anger-bregret-leave-voters-protest-vote-thought-uk-stay-in-eu-remain-win-a7102516.html_plot.png
// module id = 396
// module chunks = 0